<p>update-device-state-dialog works!</p>
